import { PROFILE_FIELDS } from '@accheyrishtey/shared';
import { Icon } from '../ui/Icon';
import { EXTRA_FILTERS, FILTER_BINDINGS, FILTER_PARAM_KEYS } from './filterConfig';

const labels = new Map(FILTER_BINDINGS.flatMap((binding) => binding.params.map((key, index) => [key, `${binding.label ?? binding.field.label}${binding.kind === 'range' ? (index === 0 ? ' from' : ' to') : ''}`])));
for (const item of EXTRA_FILTERS) labels.set(item.key, item.label);
labels.set('submitted_from', 'Submitted from'); labels.set('submitted_to', 'Submitted to');

export function FilterChips({ params, onChange }: { params: URLSearchParams; onChange: (params: URLSearchParams) => void }) {
  const chips = Array.from(params.entries()).filter(([key]) => FILTER_PARAM_KEYS.has(key));
  if (chips.length === 0) return null;
  const remove = (key: string, value: string) => {
    const next = new URLSearchParams(params);
    const remaining = next.getAll(key).filter((item) => item !== value);
    next.delete(key); for (const item of remaining) next.append(key, item);
    next.delete('page'); onChange(next);
  };
  const clear = () => {
    const next = new URLSearchParams(params);
    for (const key of FILTER_PARAM_KEYS) next.delete(key);
    next.delete('page'); onChange(next);
  };
  return <div className="filter-chips" aria-label="Active filters">{chips.map(([key, value]) => <button key={`${key}-${value}`} onClick={() => remove(key, value)}>{labels.get(key) ?? PROFILE_FIELDS.find((field) => field.key === key)?.label ?? key}: {value}<Icon name="close"/></button>)}{chips.length > 2 ? <button className="filter-chips__clear" onClick={clear}>Clear all</button> : null}</div>;
}
